/**
 * Whether the tender page offers «Подготовить тендерную документацию (beta)».
 *
 * OFF since 2026-10-01 (owner's call). The button went live on 27.09 10:18
 * Tashkent, directly under «Открыть оригинал тендера» — the one control on the
 * lot that sells — and it was the ONLY change on the path to payment between
 * the last week that converted and the first that did not: visitors who were
 * not from an ad and paid on the day they registered ran at 5–7 % for three
 * weeks (10/196, 14/243, 16/225) and went to 0 of 125 from 27.09. Few people
 * pressed it (33 of 492 new registrants), so the link is NOT proven; hiding it
 * is the test. Measure: the share of non-ad /plans viewers who press a purchase
 * button (25 % before, 11 % on 29.09–01.10).
 *
 * A switch rather than a deletion: the component, the questionnaire, the
 * waitlist API and the admin page all stay, and a granted account still gets
 * the real panel. Flip this back to bring the button back unchanged.
 */
export const BID_WAITLIST_VISIBLE: boolean = false;
